import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchProductionPeriods,
  fetchProductionPeriod,
  createProductionPeriod,
  updateProductionPeriod,
  deleteProductionPeriod,
  type FetchProductionPeriodsInput,
  type CreateProductionPeriodInput,
  type UpdateProductionPeriodInput,
} from '../api/fetch-production-periods.api';
import type { ApiError } from '@/utils/types';

export const getProductionPeriods = createAsyncThunk(
  'ProductionReporting/getProductionPeriods',
  async (params: FetchProductionPeriodsInput, thunkAPI) => {
    try {
      return await fetchProductionPeriods(params);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to fetch production periods'
      );
    }
  }
);

export const getProductionPeriodById = createAsyncThunk(
  'ProductionReporting/getProductionPeriodById',
  async (id: string, thunkAPI) => {
    try {
      return await fetchProductionPeriod(id);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to fetch production period'
      );
    }
  }
);

export const postProductionPeriod = createAsyncThunk(
  'ProductionReporting/postProductionPeriod',
  async (body: CreateProductionPeriodInput, thunkAPI) => {
    try {
      return await createProductionPeriod(body);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to create production period'
      );
    }
  }
);

export const updateProductionPeriodById = createAsyncThunk(
  'ProductionReporting/updateProductionPeriodById',
  async (
    { id, body }: { id: string; body: UpdateProductionPeriodInput },
    thunkAPI
  ) => {
    try {
      return await updateProductionPeriod(id, body);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to update production period'
      );
    }
  }
);

export const deleteProductionPeriodById = createAsyncThunk(
  'ProductionReporting/deleteProductionPeriodById',
  async (id: string, thunkAPI) => {
    try {
      return await deleteProductionPeriod(id);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to delete production period'
      );
    }
  }
);
